export default {
  login: {
    title: "ورود به حساب کاربری صرافی ارز دیجیتال اکسکوینو",
    description:
      "بعد از ثبت نام در صرافی آنلاین ارز دیجیتال اکسکوینو میتوانید از طریق همین صفحه وارد حساب کاربری خود شده و خرید و فروش ارز دیجیتال را شروع کنید"
  },
  register: {
    title: "ثبت نام در صرافی آنلاین ارز دیجیتال اکسکوینو",
    description:
      "برای ثبت نام در صرافی آنلاین ارز دیجیتال اکسکوینو با شماره ملی و شماره تماس خود می‌ توانید از طریق همین صفحه در سریع ترین زمان اقدام کنید"
  },
  virtualTrading: {
    title: "بازار آزمایشی | اکسکوینو",
    description:
      "با بازار آزمایشی (دمو تریدینگ) اکسکوینو به راحتی میتوانید خرید و فروش ارز دیجیتال را یاد بگیرید، بدون اینکه نگران ضرر مالی باشید."
  }
};
